<template>
  <div class="position-relative">
    <span
      class="playhera-icon mx-4 cursor-pointer"
      @click.prevent="
        $event =>
          openSharingMenu({
            event: $event,
            type: account._type,
            text: `${$filters.displayName(account)} ${$t(
              '_web_' + account._type,
              account._type
            )} on `,
            id: account._id,
            vanityId: account.vanityId,
          })
      "
    >
      <Icon name="share" />
    </span>
    <router-link
      :to="{
        name: $routerNames.EDIT,
        params: {
          ...account.params,
          ...$route.params,
        },
      }"
    >
      <Icon name="settings-outline" />
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/components/atoms/Icon';

import { sharingMenu } from '@/mixins/sharingMenu';
export default {
  name: 'AccountStatusBarActionsEditProfile',
  components: {
    Icon,
  },
  mixins: [sharingMenu],
  computed: {
    ...mapState('current', ['account']),
  },
};
</script>
